<template>
  <v-dialog v-model="dialog_notification" max-width="490">
    <v-card>
      <v-card-title class="success white--text" v-if="flag">Success</v-card-title>
      <v-card-title class="error white--text" v-else>Error</v-card-title>
      <v-card-text v-html="text"></v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn id="dialog_close" color="error" text @click.stop="dialog_notification = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialogNotification',
  props: ['visible', 'text', 'flag'],
  watch: {
    dialog_notification() {
      setTimeout(function() {
        const closeBtn = document.getElementById('dialog_close');
        if (closeBtn) {
          closeBtn.focus();
        }
      }, 500);
    }
  },
  computed: {
    dialog_notification: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit('close');
        }
      }
    }
  }
};
</script>